<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="storeName" >
        <span slot="label" ><a-tooltip>{{$t('门店名称')}}<template slot="title">{{$t('门店名称')}}</template></a-tooltip> </span>
        <a-input v-model="form.storeName" :maxLength="255" :placeholder="$t('请输入')+'门店名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="storeMobile" >
        <span slot="label" ><a-tooltip>{{$t('手机号')}}<template slot="title">请输入正确有效的手机号, 用于登录</template></a-tooltip> </span>
        <a-input v-model="form.storeMobile" :disabled="formType===2" :placeholder="$t('请输入')" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="storeLogo" >
        <span slot="label" ><a-tooltip>{{$t('门店logo')}}<template slot="title">{{$t('门店logo')}}</template></a-tooltip> </span>
        <oss-upload-single v-model="form.storeLogo" prefix="merchant" type="img"/>
      </a-form-model-item>
<!--      <a-form-model-item prop="storeBackground" >
        <span slot="label" ><a-tooltip>{{$t('商家背景图')}}<template slot="title">{{$t('商家背景图')}}</template></a-tooltip> </span>
        <oss-upload-single v-model="form.storeBackground" prefix="merchant" type="img"/>
      </a-form-model-item>-->
      <a-form-model-item prop="storeAreax" >
        <span slot="label" ><a-tooltip>{{$t('门店所在地')}}<template slot="title">{{$t('门店所在地')}}</template></a-tooltip> </span>
        <a-cascader :options="areaList"
                    :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                    :placeholder="$t('请选择')+'商家所在地'"
                    style="width: 100%" v-model="areaSelected" allowClear @change="onAreaChange">
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item prop="storeAddress" >
        <span slot="label" >
          <a-tooltip>
            详细地区<template slot="title">详细地区</template>
          </a-tooltip>
        </span>
        <div id="amap" style="height: 450px; width: 470px">
          <merchant-map ref="merchantMap" @updateLocationMap="updateLocationMap"   style="height: 100%;" />
        </div>
      </a-form-model-item>
      <a-form-model-item prop="storeStatus" >
        <span slot="label" ><a-tooltip>{{$t('门店状态')}}<template slot="title">{{$t('门店状态')}}</template></a-tooltip> </span>
        <a-radio-group v-model="form.storeStatus" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.StatusEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="storeDescription" >
            <span slot="label" ><a-tooltip>{{$t('门店简介')}}<template slot="title">{{$t('商家简介')}}</template></a-tooltip> </span>
            <a-input v-model="form.storeDescription" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="businessTime" >
          <span slot="label" ><a-tooltip>{{$t('营业时间')}}<template slot="title">{{$t('营业时间')}}</template></a-tooltip> </span>
          <a-input v-model="form.businessTime" :maxLength="128" :placeholder="$t('请输入')+'营业时间'" >
          </a-input>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getMerchantStore, addMerchantStore, updateMerchantStore} from '@/api/merchant/merchantStore'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import moment from 'moment';
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import {areaListTree} from "@/api/logistics";
import MerchantMap from "@/views/common/map.vue";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    MerchantMap,
    OssUploadSingle,
    CustomDictTag,
    LocaleFieldButton,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      areaList: [],
      areaSelected: [],
      loading: '',
      // 表单参数
      form: {
        id: null,
        merchantId: null,
        storeName: null,
        storeMobile: undefined,
        storeLogo: null,
        storeBackground: null,
        storeAreax: null,
        storeAddress: null,
        storeLongitude: null,
        storeLatitude: null,
        storeStatus: 1,
        storeDescription: null,
        businessTime: null,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        storeName: [{required: true, message: this.$t('门店名称') + this.$t('不能为空'), trigger: 'blur'}],
        storeLogo: [{required: true, message: this.$t('商家logo') + this.$t('不能为空'), trigger: 'blur'}],
        storeBackground: [{required: true, message: this.$t('商家背景图') + this.$t('不能为空'), trigger: 'blur'}],
        storeAddress: [{required: true, message: this.$t('详细地区') + this.$t('不能为空'), trigger: 'blur'}],
        storeStatus: [{required: true, message: this.$t('门店状态') + this.$t('不能为空'), trigger: 'blur'}],
        storeAreax: [{required: true, message: this.$t('门店所在地') + this.$t('不能为空'), trigger: 'change'}],
        storeMobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }, {pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: '请正确填写手机号', trigger: 'blur'}
        ]

      }
    }
  },
  filters: {},
  created() {
    this.getAreaTree()

  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    moment,
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      this.$refs.merchantMap.initMarker(null, null, null, null);
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        merchantId: null,
        storeName: null,
        storeMobile: undefined,
        storeLogo: null,
        storeBackground: null,
        storeAreax: null,
        storeAddress: null,
        storeLongitude: null,
        storeLatitude: null,
        storeStatus: 1,
        storeDescription: null,
        businessTime: null,
        remark: null,
        localeFieldMap: {},
      }
      this.areaSelected = []

    },

    getAreaTree() {
      areaListTree().then(response => {
        this.areaList = response.data
      })
    },
    initMap() {
      let longitude = this.form.storeLongitude
      let latitude = this.form.storeLatitude
      let areac = this.form.storeAreax
      let detailedAddress = this.form.storeAddress
      this.$refs.merchantMap.initMarker(longitude, latitude, areac, detailedAddress);
    },
    updateLocationMap(data) {
      console.log('地图选点', data)
      this.form.storeLatitude = data.lat
      this.form.storeLongitude = data.lon
      this.form.storeAddress = data.orgAddr
    },
    onAreaChange(value, selectedOptions) {
      this.form.storeAreax = value[2]
      console.log('onAreaChange', this.form.storeAreax)
      //初始化地图
      this.$refs.merchantMap.initMarker(selectedOptions[2].longitude, selectedOptions[2].latitude, value[1], '');
    },

    /** 新增按钮操作 */
    handleAdd(merchantId) {
      this.reset()
      this.formType = 1
      this.form.merchantId = merchantId
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMerchantStore({"id": id}).then(response => {
        this.form = response.data
        this.areaSelected.push(response.data.storeAreap);
        this.areaSelected.push(response.data.storeAreac);
        this.areaSelected.push(response.data.storeAreax);
        this.open = true
        this.formTitle = this.$t('修改')
        this.$nextTick(()=>{
          this.initMap()
        })
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateMerchantStore(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addMerchantStore(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
